<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import { Person } from '../../modules/eventsApi/persons/person'
    import type { PaymentLink } from '../../modules/paymentsApi/payment-links/payment-link.entity'
    import Fa from 'svelte-fa'
    import { faCopy } from '@fortawesome/free-solid-svg-icons'
    import type { Purchase } from '../../modules/paymentsApi/purchases/purchase.entity'
    // ##############################################################################################################
    const dispatch = createEventDispatcher()

    export let purchaseId: string
    let person: Person = null

    let purchase: Purchase = null
    let showAlert = false
    async function loadPurchase() {
        purchase = await window.api.payments.purchases.getOne(purchaseId)
        person = new Person()
        person.personId = purchase.referenceId
        showAlert = !!purchase.referenceId
    }

    onMount(async () => {
        await loadPurchase()
    })

    let linkUrl: string = ''

    async function updateCustomer() {
        try {
            if (!person) {
                window.error('Informe o cliente')
                return
            }
            const dto = {
                referenceId: person.personId,
            }
            await window.api.payments.purchases.update(purchase.purchaseId, dto)
            dispatch('close')
        } catch (error) {
            window.error(error.message || error)
        }
    }
</script>

<div class="root">
    <div class="grid-form">
        {#if showAlert}
            <div class="row">
                <div class="col">
                    <div class="alert alert-primary text-center">
                        Atenção: utilize esta opção apenas se o cliente atual foi informado de forma errada.
                    </div>
                </div>
            </div>
        {/if}
        <div class="row">
            <div class="col">
                <ZentitySelect fonte="pessoa" bind:value={person} label="Selecione o novo cliente" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="text-center mt-1">
                    <button class="btn btn-primary" on:click={updateCustomer}
                        ><Fa icon={faCopy} /> Atualizar cliente</button
                    >
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .row {
        padding: 0px 16px;
    }
</style>
